import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';

export default function Dashboard() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main
        className="max-w-2xl mx-auto px-4 md:px-6 flex flex-col items-center justify-center text-center"
        style={{ minHeight: 'calc(100vh - 200px)' }}
      >
        <p className="text-xs tracking-widest uppercase text-foreground-400 mb-4">
          {t('common.question.dashboard')}
        </p>
        <h1 className="text-3xl md:text-4xl mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
          {t('nav.dashboard')}
        </h1>
        <p className="text-foreground-500 max-w-md leading-relaxed mb-10">
          個人總覽與進度 — 即將開放
        </p>
        <Link
          to="/weekly-practice"
          className="whitespace-nowrap px-6 py-2.5 rounded-md bg-foreground-900 text-background-50 text-sm hover:bg-foreground-800 transition-colors cursor-pointer"
        >
          {t('common.nextStep.dashboard')}
        </Link>
        <p className="mt-12 text-xs text-foreground-300">
          {t('common.stage.continue')}
        </p>
      </main>
      <Footer />
    </div>
  );
}